import { QuestTypeEnum } from "sandpiper_api";

const questTypeEnum = new QuestTypeEnum();

export default {
    methods: {
        questTypeClass(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'impulse';
                case questTypeEnum.more:
                    return 'more';
                case questTypeEnum.smart:
                    return 'smart';
                case questTypeEnum.together:
                    return 'together';
            }

            return 'neutral';
        },
        questTypeClassBackground(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'impulse-background';
                case questTypeEnum.more:
                    return 'more-background';
                case questTypeEnum.smart:
                    return 'smart-background';
                case questTypeEnum.together:
                    return 'together-background';
            }

            return 'neutral-background';
        },
        questTypeClassFont(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'impulse-font';
                case questTypeEnum.more:
                    return 'more-font';
                case questTypeEnum.smart:
                    return 'smart-font';
                case questTypeEnum.together:
                    return 'together-font';
            }

            return 'neutral-font';
        },
        questTypeToString(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'Beweeg tussendoor';
                case questTypeEnum.more:
                    return 'Beweeg meer';
                case questTypeEnum.smart:
                    return 'Beweeg slim';
                case questTypeEnum.together:
                    return 'Beweeg samen';
            }

            return '';
        },
        getQuestTypeFontAwesomeClass(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'fa-bolt';
                case questTypeEnum.more:
                    return 'fa-rocket';
                case questTypeEnum.smart:
                    return 'fa-lightbulb';
                case questTypeEnum.together:
                    return 'fa-users';
            }
            return '';
        },
        questTypeColor(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return "#FD84FF";
                case questTypeEnum.more:
                    return "#FF5A31";
                case questTypeEnum.smart:
                    return '#00B9FF';
                case questTypeEnum.together:
                    return '#9FDC60';
            }
            return '#fff';
        },

        questTypeIconClass(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'impulse-icon';
                case questTypeEnum.more:
                    return 'more-icon';
                case questTypeEnum.smart:
                    return 'smart-icon';
                case questTypeEnum.together:
                    return 'together-icon';
            }
            return '';
        },

        questTypeOutlinedIconClass(questType)
        {
            switch (questType)
            {
                case questTypeEnum.impulse:
                    return 'impulse-icon-outline';
                case questTypeEnum.more:
                    return 'more-icon-outline';
                case questTypeEnum.smart:
                    return 'smart-icon-outline';
                case questTypeEnum.together:
                    return 'together-icon-outline';
            }
            return '';
        },
    }
}